module.exports = __webpack_public_path__ + "assets/img/thumb-Logitech-BRIO-Video-Animation-Video.de3f7dc7.webp";